import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { RouterConstants } from 'src/app/core/constants/router.constants';
import { MenuItem } from './menu.model';
import { Subject } from 'rxjs';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { ConfirmationAlertComponent } from '../confirmation-alert/confirmation-alert.component';
import { ApiService } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, AfterViewInit, OnDestroy {

  docElement: any;
  userUrl: any = '';
  userName: any = '';
  userId: any;
  imgData: any;
  menuItems: any = [];
  flagImage: any = false;
  _mPanicActionFlag: boolean = true;
  _mLogo: any = '';
  // username: String;
  // companyId: number;
  mapType: any;
  _currentUser: any;
  lastLogin: any;
  _currentUserData: any;
  // roleid: number;
  // _mRoute: string;
  // _mSubRoute: string;
  // client_code: string;
  // sub: Subscription;
  // subs: Subscription;
  panicActionData: any[] = [];
  // notificationCount: number = null;
  subscriptionRequests: any = [];
  // cancelRequest: ModelSubscription;
  notificationData: any = {};
  private dataToContainer$ = new Subject();
  userInactive: Subject<any> = new Subject();
  routingInactive: Subject<any> = new Subject();
  userActivity;
  routingActivity;
  _rolePermissions: any;
  _mRestrictCovid: any = false;
  _mCheck: any = false;
  // atomSession: Subscription;
  settings: boolean = false;
  configuration: boolean = false;
  count: any = '';
  notifications: any = [];
  notificationFlag: boolean = true;
  searchSubject$ = new Subject<string>();
  // _mCurrentUserData: any = this.localStorage.getUserObject();
  // id: any = this.localStorage.getUserId();
  empSearchFlag: boolean = false;
  empData: any = [];
  contextSearch: any = "";
  contextSearchEmployeeFlag: boolean = false;
  contextSearchVehicleFlag: boolean = false;
  contextSearchDriverFlag: boolean = false;
  filterValue: any = 'Filter';
  filterFlag: boolean = true;
  employeeFlag: boolean = false;
  vehicleFlag: boolean = false;
  driverFlag: boolean = false;
  public filterDropDown = [{ value: "Employee" }, { value: "Vehicle" }, { value: "Driver" }];
  _mCurrentNumber: number = 0;
  _mPreviousPageNumber: number = 0;
  _mTotalPage: number = 1;
  _mTotalElements: number = 0;
  _mNumberOfElements: any
  _mSize: number = 0;
  page: number = 1;
  size: number = 10;
  searchDriver: any = '';
  searchVehicle: any = '';
  driverData: any[] = [];
  _mColumns: any[] = [];
  searchSubjectDriver$ = new Subject<string>();
  searchSubjectVehicle$ = new Subject<string>();
  tempSearchKey: any;
  vehicleData: any;
  temDriverpData: any = [];
  _contextSearch: boolean = false;
  aichatbot: boolean = false;
  userData: any;
  vendorFlag: boolean = false;
  filterVehicle: boolean = false;
  searchSubjectBasedOnVendor$ = new Subject<string>();
  mVendorMasterId: any;
  vendorMasterFlag: boolean = false;
  tempVehicleData: any = [];
  billingAccess: boolean = false;
  betaIcon: boolean = false;
  alertOverspeeding: boolean = false;
  cancelledArray: any[] = [];
  deviationCancelledArray: any[] = [];
  alertRouteDeviation: boolean = false;
  logo_Url: any = '';
  isMobileMenuOpen = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private sanitizer: DomSanitizer,
    private router: Router,
    public dialog: MatDialog,
    private readonly apiService: ApiService,
    private readonly localStorage: ServiceLocalStorage,
  ) {
    // this.apiService.doGetRequestWithResponse(ApiConstants.getCurrentUser,
    //   success => {
    //     this.empSearchFlag = false;
    //     this.userData = success.body.userInfoDetails;
    //     this.billingAccess = success.body.billingAccess;
    //     if (this.userData.role.name == 'Vendor') {
    //       this.vendorFlag = true;
    //       this.vehicleFlag = true;
    //       this.filterVehicle = true;
    //       this.filterDropDown = [{ value: "Vehicle" }, { value: "Driver" }];
    //       this.getVendorByUserId(success.body.id);
    //     }
    //   },
    //   error => {
    //     this.empSearchFlag = false;
    //   }
    // );

    // this.localStorage.getProfileObs().subscribe((res: any) => {
    //   this.userUrl = res;
    // });

    // this.localStorage.getFirstNameObs().subscribe((result: any) => {
    //   this.userName = result ? result : window.sessionStorage.getItem('userName') !== null ? window.sessionStorage.getItem('userName') : '';
    // })

    // router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.activateMenu();
    //   }
    // });

  }

  ngOnInit(): void {
    this.docElement = document.documentElement;
    this._rolePermissions = this.localStorage.getPermissionObject();
    this.settings = this._rolePermissions.find(ele => ele.menuCode === 'settings');
    this.configuration = this._rolePermissions.find(ele => ele.menuCode === 'configuration');
    this.initialize();
  }

  resetUserTimer() {
    clearTimeout(this.userActivity);
    this.setUserTimeout();
  }

  setUserTimeout() {
    if (this.localStorage.hasAuthToken()) {
      this.userActivity = setTimeout(() => {
        this.userInactive.next("General");
      }, 900000);
    }
  }

  resetRoutingTimer() {
    clearTimeout(this.routingActivity);
    this.setRoutingTimeout();
  }

  setRoutingTimeout() {
    if (this.localStorage.hasAuthToken()) {
      this.routingActivity = setTimeout(() => {
        this.routingInactive.next("Routing");
      }, 7200000);
    }
  }

  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  initialize(): void {
    this.menuItems = [
      // {
      //   id: 1,
      //   label: 'MyProfile',
      //   link: '/' + RouterConstants.layoutContainer + '/' + RouterConstants.userProfile.myProfile,
      //   icon: 'bx-home-circle',
      //   permission: this._rolePermissions.find(ele => ele === 'myProfile'),
      // },
      {
        id: 2,
        label: 'Dashboard',
        icon: 'bx-home-circle',
        link: '/' + RouterConstants.layoutContainer + '/' + RouterConstants.dashboard.baseUrl,
        permission: this._rolePermissions.find(ele => ele.menuCode === 'dashboard'),
        isUiElement: true,
      },
      {
        id: 3,
        label: 'Operations',
        icon: 'bx-customize',
        permission: this._rolePermissions.find(ele => ele.menuCode === 'operation'),
        subItems: [
          {
            id: 4,
            label: 'Vendor',
            link: '/' + RouterConstants.layoutContainer + '/' + RouterConstants.operations.baseUrl + '/' + RouterConstants.operations.vendor,
            permission: this._rolePermissions.find(ele => ele.menuCode === 'vendor'),
          },
          {
            id: 5,
            label: 'User',
            link: '/' + RouterConstants.layoutContainer + '/' + RouterConstants.operations.baseUrl + '/' + RouterConstants.operations.user,
            permission: this._rolePermissions.find(ele => ele.menuCode === 'user'),
          },
        ]
      },
      {
        id: 100,
        label: 'Reports',
        icon: 'bx-file',
        link: '/' + RouterConstants.layoutContainer + '/' + RouterConstants.reports.baseUrl,
        permission: this._rolePermissions.find(ele => ele.menuCode === 'reports')
      },]
  }

  onMenuClick(event: any) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      nextEl.classList.toggle("show");
    }
    return false;
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.docElement.mozFullScreenElement &&
      !this.docElement.webkitFullscreenElement) {
      if (this.docElement.requestFullscreen) {
        this.docElement.requestFullscreen();
      } else if (this.docElement.mozRequestFullScreen) {
        /* Firefox */
        this.docElement.mozRequestFullScreen();
      } else if (this.docElement.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.docElement.webkitRequestFullscreen();
      } else if (this.docElement.msRequestFullscreen) {
        /* IE/Edge */
        this.docElement.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  ngAfterViewInit() {
    this.activateMenu();
  }

  activateMenu() {
    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
                const menuelement = document.getElementById("topnav-menu-content")
                if (menuelement !== null) {
                  if (menuelement.classList.contains('show'))
                    document.getElementById("topnav-menu-content").classList.remove("show");
                }
              }
            }
          }
        }
      }
    };
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    for (let i = 0; i < links.length; i++) {
      resetParent(links[i]);
    }
    for (let i = 0; i < links.length; i++) {
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }
  }

  myProfile() {
    this.router.navigate(['/' + RouterConstants.layoutContainer + '/' + RouterConstants.userProfile.baseUrl + '/' + RouterConstants.userProfile.myProfile]);
  }

  changePassword() {
    this.router.navigate(['/' + RouterConstants.layoutContainer + '/' + RouterConstants.userProfile.baseUrl + '/' + RouterConstants.userProfile.changePassword]);
  }

  transform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.userUrl);
  }

  getProfilePhoto() {
    // this.userId = this.localStorage.getUserId();
    // if (this.userId) {
    //   this.apiService.doGetRequestWithResponse(ApiConstants.getprofilePhoto + this.userId + '&driverId=', success => {
    //     if (success.status === 200) {
    //       this.imgData = success.body;
    //       if (this.imgData) {
    //         this.userUrl = this.imgData.url;
    //       } else {
    //         this.userUrl = '';
    //       }
    //     } else {
    //       this.imgData = '';
    //       this.userUrl = '';
    //     }
    //   }, error => {
    //     console.log(error)
    //   });
    // }
  }

  logout(): void {
    const dialogRef = this.dialog.open(ConfirmationAlertComponent, {
      width: '324px',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.localStorage.deleteAll();
        this.router.navigate(['/' + RouterConstants.auth]);
      }
    });
  }

  clearTimer() {
    clearTimeout(this.userActivity);
    clearTimeout(this.routingActivity);
  }

  @HostListener('window:mousemove') refreshUserState() {
    if (this.localStorage.hasAuthToken()) {
      this.resetUserTimer();
      this.resetRoutingTimer();
    }
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  onClickSetting() {
    this.router.navigate(['/' + RouterConstants.layoutContainer + '/' + RouterConstants.settings.baseUrl]);
  }

  onClickConfiguration() {
    this.router.navigate(['/' + RouterConstants.layoutContainer + '/' + RouterConstants.configurations.baseUrl]);
  }

  clearNotification() {
    // let userId = this.localStorage.getUserId();
    // if (userId) {
    //   this.apiService.doGetRequestWithResponse(ApiConstants.markNotifications, success => {
    //     if (success.status == 200) {
    //       this.getLatestNotifications();
    //       this.getNotificationCount();
    //     } else {
    //       this.notifyService.showInfo("No new notifications", null);
    //     }
    //   }, error => {
    //     console.log(error);
    //   })
    // } else {
    //   this.notifyService.showInfo("Fail to clear notifications", null);
    // }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  goTo(link: string) {
    this.isMobileMenuOpen = false; // close after click
    this.router.navigate([link]);
  }


}
